/** macOS-/Picker-IDs → offizielle iPhone-/iPad-Bundle-IDs (Apple Deployment). */
export const IOS_APP_BUNDLE_ALIASES = {
  "com.apple.Photos": "com.apple.mobileslideshow",
  "com.apple.FindMy": "com.apple.findmy",
  "com.apple.Freeform": "com.apple.freeform",
};

export function canonicalIosAppBundleId(bundleId) {
  const id = String(bundleId || "").trim();
  return IOS_APP_BUNDLE_ALIASES[id] || id;
}

/** Eingebaute iPhone-/iPad-Apps für Layout- und Mitteilungs-Picker. */
export const BUILTIN_IOS_APPS = [
  { bundleId: "com.apple.Preferences", name: "Einstellungen" },
  { bundleId: "com.apple.Sharing.AirDropUI", name: "AirDrop" },
  { bundleId: "com.apple.mobilesafari", name: "Safari" },
  { bundleId: "com.apple.DocumentsApp", name: "Dateien" },
  { bundleId: "com.apple.camera", name: "Kamera" },
  { bundleId: "com.apple.mobileslideshow", name: "Fotos" },
  { bundleId: "com.apple.mobilenotes", name: "Notizen" },
  { bundleId: "com.apple.MobileSMS", name: "Nachrichten" },
  { bundleId: "com.apple.Translate", name: "Übersetzen" },
  { bundleId: "com.apple.mobilemail", name: "Mail" },
  { bundleId: "com.apple.mobilecal", name: "Kalender" },
  { bundleId: "com.apple.MobileAddressBook", name: "Kontakte" },
  { bundleId: "com.apple.reminders", name: "Erinnerungen" },
  { bundleId: "com.apple.mobilephone", name: "Telefon" },
  { bundleId: "com.apple.facetime", name: "FaceTime" },
  { bundleId: "com.apple.AppStore", name: "App Store" },
  { bundleId: "com.apple.Maps", name: "Karten" },
  { bundleId: "com.apple.mobiletimer", name: "Uhr" },
  { bundleId: "com.apple.calculator", name: "Rechner" },
  { bundleId: "com.apple.weather", name: "Wetter" },
  { bundleId: "com.apple.Music", name: "Musik" },
  { bundleId: "com.apple.iBooks", name: "Bücher" },
  { bundleId: "com.apple.podcasts", name: "Podcasts" },
  { bundleId: "com.apple.tv", name: "TV" },
  { bundleId: "com.apple.news", name: "News" },
  { bundleId: "com.apple.shortcuts", name: "Kurzbefehle" },
  { bundleId: "com.apple.Home", name: "Home" },
  { bundleId: "com.apple.Health", name: "Health" },
  { bundleId: "com.apple.findmy", name: "Wo ist?" },
  { bundleId: "com.apple.Passbook", name: "Wallet" },
  { bundleId: "com.apple.VoiceMemos", name: "Sprachmemos" },
  { bundleId: "com.apple.freeform", name: "Freeform" },
  { bundleId: "com.apple.journal", name: "Journal" },
  { bundleId: "com.apple.measure", name: "Maßband" },
  { bundleId: "com.apple.compass", name: "Kompass" },
  { bundleId: "com.apple.Magnifier", name: "Lupe" },
  { bundleId: "com.apple.stocks", name: "Aktien" },
  { bundleId: "com.apple.tips", name: "Tipps" },
  { bundleId: "com.apple.Photo-Booth", name: "Photo Booth" },
  { bundleId: "com.apple.MobileStore", name: "iTunes Store" },
  { bundleId: "com.apple.classroom", name: "Classroom" },
  { bundleId: "com.apple.schoolwork", name: "Schoolwork" },
  { bundleId: "com.apple.Keynote", name: "Keynote" },
  { bundleId: "com.apple.Pages", name: "Pages" },
  { bundleId: "com.apple.Numbers", name: "Numbers" },
];

export function appByBundleId(bundleId) {
  const canonical = canonicalIosAppBundleId(bundleId);
  return BUILTIN_IOS_APPS.find((app) => app.bundleId === canonical) || null;
}
